<template>
  <div>
    <div slot="title">
      <h2 class="label-black">Detalles de evaluaciones</h2>
    </div>
    <div slot="main">
      <div class="container-fluid">
        <router-link to="/SISEVA/PersonalEvaluado">
          <button v-on:click="" id="btnAtras" class="btn btn-custom"><i class="fas fa-arrow-left"></i> Atrás</button>
        </router-link>
        <hr>
        <div class="row">
          <div class="form-group col-2">
            <label class="label-black">Id Evaluado</label>
            <input type="text" class="form-control" v-model="infoPersona.PersonaId" readonly>
          </div>
          <div class="form-group col-3">
            <label class="label-black">Nombre</label>
            <input type="text" class="form-control" v-model="infoPersona.NombreCompleto" readonly>
          </div>
          <div class="form-group col-3">
            <label class="label-black">Puesto</label>
            <input type="text" class="form-control" v-model="infoPersona.Puesto" readonly>
          </div>
        </div>
        <h5 class="label-black">Resultados de la búsqueda</h5>
        <div class="row">
          <div class="col-12">
            <table class="table table-striped table-light table-hover table-sm" id="tablaEvaluaciones">
              <thead class="thead-custom">
                <tr>
                  <th class="text-center">Id de Solicitud</th>
                  <th class="text-center">Periodo de evaluación</th>
                  <th class="text-center">Fecha límite de entrega</th>
                  <th class="text-center">Fecha de termincación</th>
                  <th class="text-center">Puestos</th>
                  <th class="text-center">Departamento</th>
                  <th class="text-center">Estatus de evaluación</th>
                  <th class="text-center">Acciones</th>
                </tr>
              </thead>
              <tbody class='text-dark'>
                <tr v-for='evaluacion in evaluaciones'>
                  <td>#{{ evaluacion.SolicitudEvaluacionId }}</td>
                  <td>{{evaluacion.FechaInicioPeriodoEvaluacionString}} - {{evaluacion.FechaFinPeriodoEvaluacionString}}</td>
                  <td>{{evaluacion.FechaLimiteEntregaString}}</td>
                  <td>{{evaluacion.FechaTerminacionString}}</td>
                  <td>{{evaluacion.Puesto}} <i v-if="evaluacion.AlertaHistorialLaboral" class="fas fa-exclamation-triangle" title="Problema de Historial Laboral. Favor de notificar a personal." /></td>
                  <td>{{evaluacion.Seccion}} - {{evaluacion.Departamento}}</td>
                  <td>{{evaluacion.Estatus}}</td>
                  <td class='d-flex justify-content-around'>
                    <i class='fa fa-print' title="Generar Reporte"/><i class='fa fa-info-circle' @click='verDetalles(evaluacion.EvaluacionId,evaluacion.SolicitudEvaluacionId)' title="Ver Detalles"/>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//import Layout from '@/components/SIAP/Comun/Plantilla.vue';
import catalogos from '@/../static/js/catalogos'
import comun from '@/../static/js/comun'
import enumeraciones from '@/../static/js/enumeraciones'
import api from '@/../static/js/api'
import axios from 'axios'

  export default {
  props: ['infoPersona'],
  data() {
    return {
      evaluaciones: []
    }
  },
  components: {
    //Layout
  },
    methods: {
      cargarDatosEvaluado: function () {

      },
    buscarEvaluaciones: function () { //Retorna una lista de evaluaciones pendientes en base a ciertos filtros
        //Carga la información necesaria para hacer la petición
        var peticion = {
          "esPrueba": false,
          "PersonaId": this.infoPersona.PersonaId
        };
      //console.log(peticion)
      comun.SeEstaCargandoInformacion(true);
        axios.post(api.conexion + api.SISEVA.funcion.GetEvaluacionesPersona, peticion).then(response => {
          if (response.data.SiHayError == false) {//En caso de que la petición sea exitosa
            console.log(response.data)
              this.evaluaciones= response.data.evaluaciones//Carga los datos necesarios
            
            PaginarTabla('tablaEvaluaciones',10)
          }
          else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null)
          }
          comun.SeEstaCargandoInformacion(false);
          }).catch(e => {
            console.error("encontre un error "+e);
            comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null)
          });
      },
    verDetalles: function (idEvaluacion, idSolicitud) {
        //Redirige a la página SISEVA/DetallesEvaluado, para modificar la evaluación que se haya seleccionado, se envia el id de evaluación como parametro
        this.$router.push({
        name: 'DetallesEvaluacion',
        params: { idEvaluacion: idEvaluacion, infoPersona: this.infoPersona }
    })
      }
    }, mounted: function () {
    this.buscarEvaluaciones();
  }

}

</script>

<style scoped>

  a {
    color: #fff;
  }

  input[type="text"]:read-only {
    background: #f3f3f3;
  }

    input[type="text"]:read-only:focus {
      color: #fff;
    }
  .thead-custom {
    background-color: #004746;
    color: white;
  }
  .custom-area {
        background-color: #7e7f74;
    }
    .label-black {
        color: black;
    }
    .btn-custom {
        background-color: #004746;
        color: white;
    }
</style>



// WEBPACK FOOTER //
// src/components/SISEVA/Evaluaciones/DetalleDeEvaluaciones.vue